"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderSelect = exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _formik = require("formik");
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Select = _interopRequireDefault(require("../Select"));
var _constant = require("../constant");
var _GuestPersonalInfo = require("../GuestPersonalInfo");
var _DropdownBottomSheet = _interopRequireDefault(require("./DropdownBottomSheet.proptypes"));
var _constant2 = require("./constant");
var _excluded = ["form", "handleField", "isMobileV2"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "DropdownBottomSheet__StyledContainer",
  componentId: "sc-1ljy2c8-0"
})([""]);
var renderSelect = function renderSelect(fieldProps) {
  var form = fieldProps.form,
    handleField = fieldProps.handleField,
    isMobileV2 = fieldProps.isMobileV2,
    rest = (0, _objectWithoutProperties2.default)(fieldProps, _excluded);
  var field = rest.field.name;
  return /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({}, rest, {
    onChange: function onChange(val) {
      /* istanbul ignore next */
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, val)));
      /* istanbul ignore next */
      form.setFieldTouched(field, true, false);
      /* istanbul ignore next */
      handleField((0, _defineProperty2.default)({}, field, val));
    }
    // onClick={fieldProps.onClick}
    ,
    onBlur: function onBlur(val) {
      /* istanbul ignore next */
      form.setValues(_objectSpread(_objectSpread({}, form.values), {}, (0, _defineProperty2.default)({}, field, val)));
      /* istanbul ignore next */
      form.setFieldTouched(field, true, true);
      /* istanbul ignore next */
      handleField((0, _defineProperty2.default)({}, field, val));
    },
    isMobileV2: isMobileV2
  }));
};
exports.renderSelect = renderSelect;
var DropdownBottomSheet = function DropdownBottomSheet(_ref) {
  var accessible = _ref.accessible,
    theme = _ref.theme,
    customProperties = _ref.customProperties,
    formRef = _ref.formRef,
    paxType = _ref.paxType,
    translation = _ref.translation,
    handleField = _ref.handleField,
    dataList = _ref.dataList,
    initialValue = _ref.initialValue,
    hasOtherElement = _ref.hasOtherElement;
  var _React$useState = _react.default.useState(window.innerWidth),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    windowWidth = _React$useState2[0],
    setWindowWidth = _React$useState2[1];
  /* istanbul ignore next */
  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(window.innerWidth);
      });
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(window.innerWidth);
        });
      }
    };
  }, []);
  var isMobile = windowWidth <= parseInt(_constant.BREAKPOINTS.MOBILE.replace('px', ''), 10);
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);
  var initialVal = {
    travellingWith: initialValue
  };
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, (0, _extends2.default)({}, customProperties, {
    tabIndex: !accessible ? '-1' : '0'
  }), /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    innerRef: formRef,
    initialValues: initialVal,
    enableReinitialize: true
  }, function (props) {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
      isMobile: isMobile,
      title: true
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      bold: true,
      display: "block",
      theme: theme,
      type: "sub"
    }, language.travellingWith)), /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.Container, null, isMobile && paxType === 'infant' && dataList.length > 1 ? /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
      width: 100,
      isMobile: false,
      isMobileV2: true
    }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
      component: renderSelect,
      accessible: accessible
      // alwaysShowLabel={false}
      ,
      label: language.travellingWith || _constant2.FIELDS.travellingWith.value,
      name: _constant2.FIELDS.travellingWith.name,
      theme: theme,
      items: dataList.map(function (adult) {
        return {
          label: adult.text,
          value: adult.value
        };
      }),
      handleField: handleField,
      value: props.values[_constant2.FIELDS.travellingWith.name],
      isMobile: false,
      isMobileV2: true
    })) :
    /*#__PURE__*/
    // <FieldGroup isMobile={false}>
    _react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
      width: hasOtherElement ? 100 : 50
    }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
      component: renderSelect,
      accessible: accessible,
      alwaysShowLabel: false,
      label: language.travellingWith || _constant2.FIELDS.travellingWith.value,
      name: _constant2.FIELDS.travellingWith.name,
      theme: theme,
      items: dataList.map(function (adult) {
        return {
          label: adult.text,
          value: adult.value
        };
      }),
      handleField: handleField,
      value: props.values[_constant2.FIELDS.travellingWith.name]
      // validate={(val) => validate.required(val, language.gender || FIELDS.gender.label, language)}
      ,
      isMobile: false,
      isMobileV2: false
    }))
    // </FieldGroup>
    ));
  })));
};

DropdownBottomSheet.propTypes = _DropdownBottomSheet.default.PropTypes;
DropdownBottomSheet.defaultProps = _DropdownBottomSheet.default.DefaultProps;
var _default = DropdownBottomSheet;
exports.default = _default;